module.exports = __webpack_public_path__ + "img/right_img2.2d328e2d.png";